import React from 'react';
import Dumbo from '../../../../../DeviationViews/Dumbo';
import { useCurrentTier } from '../../../../_hocs/withCurrentTier';
import s from './TierSidebar.scss';

export interface Props {}

const TierSidebar: React.FC<Props> = props => {
  const { currentTier } = useCurrentTier();

  if (!currentTier) {
    return null;
  }

  const coverWidth = 343;
  const coverHeight = 224;

  const coverImage = currentTier.coverImage;

  return (
    <div className={s['root']}>
      <div className={s['sidebar']}>
        <div className={s['cover-wrapper']}>
          {coverImage && (
            <Dumbo
              className={s['cover']}
              deviation={coverImage}
              width={coverWidth}
              height={coverHeight}
            />
          )}
        </div>
        <div className={s['form']}>
          <h1>{currentTier.title!}</h1>
        </div>
      </div>
    </div>
  );
};
TierSidebar.displayName = 'TierSidebar';

export default TierSidebar;
